import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './lang/en';
import zh from './lang/zh';
import ja from './lang/ja';
import store from '@/store';
import elementEnLocale from 'element-ui/lib/locale/lang/en';
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import elementJaLocale from 'element-ui/lib/locale/lang/ja'


Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: store.state.language || 'zh',
  fallbackLocale: 'zh',
  messages: {
    en: {
        ...en,
        ...elementEnLocale
    },
    zh: {
        ...zh,
        ...elementZhLocale
    },
    ja: {
        ...ja,
        ...elementJaLocale
    }
  }
})

export default i18n
